import React from 'react'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/music.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const Music = () => (

<div className="music" id="music">



    <div className="wow slideInUp music-player_enclosure" id="tpc_music" data-wow-offset="200">

  {
      // <img className="album-cover" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Music/Artwork/TPC_cover.jpg" />
  }

      <iframe
      title="tpc_player"
      className="music-player"
      id="tpc_player"
      src="https://bandcamp.com/EmbeddedPlayer/album=71792589/size=large/bgcol=ffffff/linkcol=0687f5/transparent=true/"
      seamless
      >
        <a href="http://alfamatrix.bandcamp.com/album/total-progressive-collapse-bonus-tracks-version">
          Total Progressive Collapse (Bonus Tracks Version) by ENTRZELLE
        </a>
      </iframe>

    </div>

    <div className="wow slideInUp music-player_enclosure" id="potm_music" data-wow-offset="300">

      <iframe
      title="potm_player"
      className="music-player"
      id="potm_player"
      src="https://bandcamp.com/EmbeddedPlayer/album=873029036/size=large/bgcol=ffffff/linkcol=0687f5/transparent=true/"
      seamless
      >
        <a href="http://alfamatrix.bandcamp.com/album/part-of-the-movement-bonus-tracks-version">
          Part Of The Movement (Bonus Tracks Version) by ENTRZELLE
        </a>
      </iframe>

    </div>



    <div className="wow slideInUp music-player_enclosure" id="stwof_music" data-wow-offset="400">

      <iframe
      title="stwof_player"
      className="music-player"
      id="stwof_player"
      src="https://bandcamp.com/EmbeddedPlayer/album=4162682664/size=large/bgcol=ffffff/linkcol=0687f5/transparent=true/"
      seamless
      >
        <a href="http://alfamatrix.bandcamp.com/album/set-these-walls-on-fire-ep">
          Set These Walls On Fire EP by ENTRZELLE
        </a>
      </iframe>

    </div>










</div>

// closes 'music'


)

export default Music



// WEBPACK FOOTER //
// ./src/components/music.js